import React from 'react';
import css from "./About.module.css";

const About = () => {
    return (
		<section className={css.about}>
			<h2>About</h2>
			<p>About page</p>
		</section>
	);
}

export default About;
